'use client';
import React from 'react';
import clsx from 'clsx';
import { AccordionList } from '@/components/accordion/AccordionList';
import { Headline } from '@/components/headline/Headline';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import { Link } from '@/components/link/Link';
import { FAQProps } from './types';
import { LAYOUT_CONFIG } from './const';

export const FAQ: React.FC<FAQProps> = ({
  headline,
  accordionList,
  ctaLink,
  ctaTitle,
  ctaDescription,
  layout = 'row',
}) => {
  const hasCTA = Boolean(ctaLink?.href && ctaLink?.title && ctaTitle);
  const layoutConfig = LAYOUT_CONFIG[layout];

  return (
    <section
      data-component-id="faq"
      className={clsx('smzh-faq container mx-auto pb-20')}
    >
      {headline && (
        <Headline
          {...headline}
          className="flex w-full items-center justify-center pb-14 text-brand-700"
        />
      )}
      <div
        className={clsx(
          'flex w-full',
          layoutConfig.desktopDirection,
          layoutConfig.mobileDirection,
          layoutConfig.gap,
        )}
      >
        <div className={clsx('w-full', layoutConfig.accordionWidth)}>
          <AccordionList {...accordionList} />
        </div>

        {hasCTA && (
          <div className={clsx('w-full', layoutConfig.ctaWidth)}>
            <div
              className={clsx(
                'flex gap-3 rounded-2xl bg-brand-800 px-6 py-11 text-white',
                layoutConfig.ctaDirection,
              )}
            >
              <div className="flex flex-col lg:max-w-[70%]">
                <span className="text-2xl font-medium">{ctaTitle}</span>
                {ctaDescription?.content && (
                  <div className="mt-2">
                    <SerializeDescription
                      className="[&_*]:text-neutral-0"
                      description={ctaDescription?.content}
                    />
                  </div>
                )}
              </div>
              {ctaLink && <Link {...ctaLink} className="!rounded-full" />}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default FAQ;
